<template>
	<!-- Button trigger modal -->
	<!-- Modal -->
	<div
		class="modal fade"
		:id="modal_id"
		tabindex="-1"
		role="dialog"
		aria-labelledby="exampleModalLabel"
		aria-hidden="true"
	>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Bundled Products can only be ordered together. So, please click Add to Cart on below products</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleModal(false)">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body" style="overflow: scroll">
					<div class="container">
						<div class="row">
							<div
								class="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4"
								v-for="(products_data, index) in getRelatedProducts"
								:key="index"
							>
								<!-- <pre>{{products_data[0].category.name}}</pre> -->
								<div class="card text-center shadow" style="height: 100%">
									<div class="card-body">
										<h5 class="card-title font-weight-bold mt-2">
											{{ products_data.product_name }}
										</h5>
										<img
											class="img-fluid"
											height="100"
											v-lazy="{
												src: getImage(products_data.related_product_price_relation.image.path),
												loading: publicPath + 'assets/images/spinner.gif',
												error: publicPath + 'assets/images/not_found.png',
											}"
										/>
										<div></div>
										<div class="font-weight-bold">
											{{ formatCurrency(products_data.related_product_price_relation.stock[0].total_price) }}
										</div>
										<button
											class="button button-primary"
											style="width: 100%"
											:disabled ="status.related_products.loading"
											@click="
												addToCart({
													product_id: products_data.id,
													product_combination_id:
													products_data.related_product_price_relation.id,
													price: products_data.lowest_price,
													warehouse_id: products_data.lowest_price_relation.warehouse_id,
												})
											"
										>
											{{status.related_products.loading ? 'Please Wait' : 'Add to cart'}}
										</button>
									</div>
								</div>
							</div>
							<!-- <Product  /> -->
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="button button-primary mt-4" data-dismiss="modal">
						Close
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters, mapActions} from "vuex";
	import Product from "../Sections/Product.vue";
	import {publicPath} from "../../../vue.config";
	import {formatCurrency} from "../../utils/common_functions";
	export default {
		props: ["modal_id"],
		components: {
			Product,
		},
		computed: {
			...mapGetters("orders", ["getRelatedProducts", "getRelatedProductsModal"]),
			...mapGetters("products", ["getStatus"]),
			...mapGetters("cart", ["status"]),
		},
		data() {
			return {
				publicPath,
			};
		},
		mounted() {
			console.log("RelatedProductsModal mounted");
		},
		methods: {
			formatCurrency,
			...mapActions("cart", ["addToCart"]),
			...mapActions("orders", ["toggleModal"]),
			getImage(path) {
				return process.env.VUE_APP_API_URL + path;
			},
		},
		watch: {
			getRelatedProducts: function(val){
				if(val.length == 0){
					$("#" + this.modal_id).modal("hide");
					this.toggleModal(false);
				}
			},
			getRelatedProductsModal: function (val) {
				console.log(val)
				let value = val ? "show" : "hide";
				$("#" + this.modal_id).modal(value);
			},
		},
	};
</script>

<style scoped>
	.card-body {
		padding: 0%;
	}
</style>
